import React from 'react';

import {
  AssignmentCategoryEnum,
  AssignmentEditUserResponseModel,
  AssignmentTypeEnum,
  BOUsersPriceAgreementRespModel,
  CustomerResponseModel,
} from 'api/backofficeApiClient';
import {
  mapICAssignmentDetailsToInitialValues,
  mapW2AssignmentDetailsToInitialValues,
  mapSCAssignmentDetailsToInitialValues,
  mapW2AssignmentDetailsToCorporateInitialValues,
  mapICAssignmentDetailsToCorporateInitialValues,
  mapSCAssignmentDetailsToCorporateInitialValues,
} from 'features/assignment/AssignmentDetailsPage/utils';
import AssignmentModal, {
  AssignmentInitialValues,
} from 'components/modals/AssignmentDataModal/AssignmentModal';
import { AssignmentEditAdminResponseModel } from 'api/adminApiClient';
import { AssignmentCreationTypeEnum } from 'components/modals/AssignmentDataModal/enum';
import { useAppSelector } from 'hooks/useAppSelector';
import {
  payCodesDetailsInfoSelector,
  payCodesSelector,
  payCodesGroupsSelector,
} from 'redux/selectors/assignmentSelectors';

type Props = {
  onSubmit: () => void;
  onClose: () => void;
  renewAssignmentInfo:
    | AssignmentEditUserResponseModel
    | AssignmentEditAdminResponseModel;
  priceAgreement?: BOUsersPriceAgreementRespModel;
  customers: CustomerResponseModel[];
  isCustomersLoaded?: boolean;
  hasActiveScheduledTerminationInFuture?: boolean;
};

export default function RenewAssignment(props: Props) {
  const {
    onClose,
    onSubmit,
    renewAssignmentInfo,
    priceAgreement,
    customers,
    isCustomersLoaded,
    hasActiveScheduledTerminationInFuture,
  } = props;
  const payCodesDetails = useAppSelector(payCodesSelector);
  const payCodesDetailsInfo = useAppSelector(payCodesDetailsInfoSelector);
  const payCodesGroups = useAppSelector(payCodesGroupsSelector);

  const getAssignmentDataModalByType = () => {
    const { assignmentCategory, assignmentType } = renewAssignmentInfo;

    if (!assignmentType || !assignmentCategory) return null;

    const isCorporate = assignmentCategory === AssignmentCategoryEnum.Corporate;
    const isRecruiter = assignmentCategory === AssignmentCategoryEnum.Recruiter;

    let initialValues: AssignmentInitialValues | null = null;

    switch (assignmentType) {
      case AssignmentTypeEnum.EEAssignment: {
        switch (assignmentCategory) {
          case AssignmentCategoryEnum.Corporate: {
            initialValues = mapW2AssignmentDetailsToCorporateInitialValues({
              details: renewAssignmentInfo,
              payCodesDetails,
              isRehireOrRenew: true,
              payCodesGroups,
              payCodesDetailsInfo,
            });
            break;
          }
          case AssignmentCategoryEnum.Recruiter: {
            initialValues = mapW2AssignmentDetailsToInitialValues({
              details: renewAssignmentInfo,
              payCodesDetails,
              isRehireOrRenew: true,
              payCodesGroups,
              payCodesDetailsInfo,
            });
            break;
          }
        }
        break;
      }

      case AssignmentTypeEnum.ICAssignment: {
        switch (assignmentCategory) {
          case AssignmentCategoryEnum.Corporate: {
            initialValues = mapICAssignmentDetailsToCorporateInitialValues({
              details: renewAssignmentInfo,
              payCodesDetails,
              isRehireOrRenew: true,
              payCodesGroups,
              payCodesDetailsInfo,
            });
            break;
          }
          case AssignmentCategoryEnum.Recruiter: {
            initialValues = mapICAssignmentDetailsToInitialValues({
              details: renewAssignmentInfo,
              payCodesDetails,
              isRehireOrRenew: true,
              payCodesGroups,
              payCodesDetailsInfo,
            });
            break;
          }
        }
        break;
      }

      case AssignmentTypeEnum.SCAssignment: {
        switch (assignmentCategory) {
          case AssignmentCategoryEnum.Corporate: {
            initialValues = mapSCAssignmentDetailsToCorporateInitialValues({
              details: renewAssignmentInfo,
              payCodesDetails,
              isRehireOrRenew: true,
              payCodesGroups,
              payCodesDetailsInfo,
            });
            break;
          }
          case AssignmentCategoryEnum.Recruiter: {
            initialValues = mapSCAssignmentDetailsToInitialValues({
              details: renewAssignmentInfo,
              payCodesDetails,
              isRehireOrRenew: true,
              payCodesGroups,
              payCodesDetailsInfo,
            });
            break;
          }
        }
        break;
      }
    }

    if (!initialValues) return null;

    return (
      <AssignmentModal
        onClose={onClose}
        onSubmit={onSubmit}
        type={assignmentType}
        isDraftAvailable={false}
        isCorporateTA={isCorporate}
        isRecruiter={isRecruiter}
        initialValues={initialValues}
        assignmentId={renewAssignmentInfo?.assignmentId}
        assignmentCreationType={AssignmentCreationTypeEnum.Renew}
        memberId={
          (renewAssignmentInfo as AssignmentEditAdminResponseModel)?.memberId
        }
        companyId={
          (renewAssignmentInfo as AssignmentEditAdminResponseModel)
            ?.memberCompanyId
        }
        workerFileInfo={
          renewAssignmentInfo.assignmentDocument?.workerInfo?.workerFile
        }
        contractorCompanyFileInfo={
          renewAssignmentInfo.assignmentDocument?.contractorCompanyInfo
            ?.workerFile
        }
        priceAgreement={priceAgreement}
        customers={customers}
        isCustomersLoaded={isCustomersLoaded}
        hasActiveScheduledTerminationInFuture={
          hasActiveScheduledTerminationInFuture
        }
      />
    );
  };

  return <>{getAssignmentDataModalByType()}</>;
}
